/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-binoculars': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M17.5 5V3.125a.625.625 0 00-.625-.625h-3.75a.625.625 0 00-.625.625V5c-.69 0-1.25.56-1.25 1.25V7.5h-2.5V6.25C8.75 5.56 8.19 5 7.5 5V3.125a.625.625 0 00-.625-.625h-3.75a.625.625 0 00-.625.625V5c-.69 0-1.25.56-1.25 1.25v7.5c.003.444.24.853.625 1.075v2.05c0 .345.28.625.625.625h5c.345 0 .625-.28.625-.625v-2.05a1.25 1.25 0 00.625-1.075V12.5h2.5v1.25c.003.444.24.853.625 1.075v2.05c0 .345.28.625.625.625h5c.345 0 .625-.28.625-.625v-2.05a1.25 1.25 0 00.625-1.075v-7.5c0-.69-.56-1.25-1.25-1.25zM6.875 16.25h-3.75V15h3.75v1.25zm.625-2.5h-5v-7.5h1.25v-2.5h2.5v2.5H7.5v7.5zm1.25-2.5v-2.5h2.5v2.5h-2.5zm8.125 5h-3.75V15h3.75v1.25zm.625-2.5h-5v-7.5h1.25v-2.5h2.5v2.5h1.25v7.5z"/>'
  }
})
